import { connect } from "react-redux";
import MonthlyValetSalary from './MonthlyValetSalary';
import { bindActionCreators } from "redux";
import {
    getInfraIDForValet,
    getMonthlyDataForValet,
    calculateSalaryForValet,
    dailyValetSalaryDistribution,
    updateSalaryStatusForValet,
    valetPenaltyListing,
    masterSalaryPenaltyListRequest
} from "../../../services/redux/Valet/Project/action";

const mapStateToProps = (state) => ({
    InfraIdList : state.CreateProject.InfraIdList,
    getValetMonthlyList: state.CreateProject.getValetMonthlyList,
    getDailySalaryDistribution: state.CreateProject.getDailySalaryDistribution,
    calulateSalary: state.CreateProject.calulateSalary,
    penaltyList: state.CreateProject.penaltyList,
    masterSalaryPenaltyListResponse: state.CreateProject.masterSalaryPenaltyListResponse
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getInfraIDForValet,
        getMonthlyDataForValet,
        calculateSalaryForValet,
        dailyValetSalaryDistribution,
        updateSalaryStatusForValet,
        valetPenaltyListing,
        masterSalaryPenaltyListRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyValetSalary);
